import { graphql } from "relay-runtime"

export const dePreparationByNameQuery = graphql`
  query dePreparationByNameQuery($preparationName: String!, $pharmaceuticalCentralNumber: String!, $skip: Boolean!) {
    de_preparationByProductName(
      preparationName: $preparationName
      pharmaceuticalCentralNumber: $pharmaceuticalCentralNumber
    ) @skip(if: $skip) {
      ... on de_SuccessPreparationDetailResult {
        result {
          composition
          distributionChannel
          isPrescriptionRequired
          name
          pharmaceuticalForm {
            ifaCode
            name
          }
          pharmaceuticalCentralNumberList {
            name
            pharmaceuticalCentralNumber
            price
            quantity
            unit
          }
          productId
        }
      }
    }
  }
`
